var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiameter = function SvgDiameter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    fillRule: "evenodd",
    d: "M4.543 15.226.676 11.099 0 11.746 7.735 20 20 8.254 12.265 0l-.676.647 3.867 4.127L4.543 15.226Zm3.272 3.393-2.579-2.752 1.642-1.572 1.566 1.67.579-.555-1.565-1.67 1.158-1.11 1.566 1.67.58-.555-1.566-1.67 1.159-1.11 1.565 1.67.58-.554-1.566-1.67 1.16-1.11 1.565 1.67.58-.555-1.566-1.67 1.159-1.11 1.565 1.67.58-.555-1.566-1.67 1.642-1.573L18.63 8.26 7.815 18.62Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    fillRule: "evenodd",
    d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  })));
};
export default SvgDiameter;